import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ButtonCustom } from "../../../components/custom/button-custom";
import { showToast } from "../../../components/custom/custom-toast";
import IconPlus from "../../../components/icons/icon-plus";
import { PAGE_SIZES } from "../../../constants/status";
import { STRING_SUB_MENU } from "../../../constants/string";
import { useFetchData } from "../../../hooks/useFetch";
import { AppVersionResponse } from "../../../models/response/app-version";
import { API_APP_VERSION_ROUTER } from "../../../services/api-config";
import { BasePaginateResponse } from "../../../services/base-response";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { AppVersionTable } from "../components/app-version-table";
import { AppVersionCreate } from "../components/modal/app-version-create";
import { AppVersionUpdate } from "../components/modal/app-version-update";

export const AppVersionPage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent(STRING_SUB_MENU.APP_VERSION));

  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  const [dataObject, setDataObject] = useState<AppVersionResponse>(new AppVersionResponse());
  const [dataAppVersion, setDataAppVersion] = useState<AppVersionResponse[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(PAGE_SIZES[0]);
  const [appType, setAppType] = useState(-1);
  const [platform, setPlatform] = useState(-1);
  const [totalRecords, setTotalRecords] = useState(0);

  const {
    request: fetchDataAppVersion,
    baseResponse: responsesData,
    loading,
  } = useFetchData.Get<BasePaginateResponse<AppVersionResponse[]>>();

  const handleData = () => {
    fetchDataAppVersion({
      endPoint: API_APP_VERSION_ROUTER.API_GET_APP_VERSION,
      data: {
        app_type: appType,
        platform: platform,
        page: page,
        limit: limit,
      },
    });
    setRefresh(false);
  };

  useEffect(() => {
    if (!responsesData) return;
    if (responsesData.status === 200) {
      setDataAppVersion(responsesData.data.list);
      setTotalRecords(responsesData.data.total_record);
    } else {
      showToast({ message: responsesData.message, type: "error" });
    }
  }, [responsesData]);

  useEffect(() => {
    if (refresh) handleData();
  }, [refresh]);
  useEffect(() => {
    handleData();
  }, [limit, page, appType, platform]);

  return (
    <div className="flex flex-col gap-3 w-full">
      <div className=" flex justify-end gap-4 " id="tab-menu">
        <ButtonCustom type="submit" text="Thêm mới" onClick={() => setIsOpenCreate(true)} icon={<IconPlus />} />
      </div>
      <AppVersionTable
        loadingTable={loading}
        dataAppVersion={dataAppVersion}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        totalRecords={totalRecords}
        setOpenModalUpdate={setIsOpenUpdate}
        setDataObject={setDataObject}
        setAppType={setAppType}
        setPlatform={setPlatform}
      />
      <AppVersionCreate isOpen={isOpenCreate} setIsOpen={setIsOpenCreate} setRefresh={setRefresh} />
      {isOpenUpdate && (
        <AppVersionUpdate
          isOpen={isOpenUpdate}
          setIsOpen={setIsOpenUpdate}
          setRefresh={setRefresh}
          dataObject={dataObject}
        />
      )}
    </div>
  );
};
